const noop = Function.prototype;

// we only want to run this client-side
let clientLogger = {
    captureBreadcrumb: noop,
    captureException: noop,
    captureMessage: noop
};
/* istanbul ignore if */
if (typeof window !== 'undefined' && window.Raven) {
    if (process.env.NODE_ENV !== 'production') {
        clientLogger.captureBreadcrumb = (...args) =>
            console.log('%cBreadcrumb: ', 'font-weight: bold', ...args); // eslint-disable-line no-console
        clientLogger.captureException = console.error; // eslint-disable-line no-console
        clientLogger.captureMessage = console.log; // eslint-disable-line no-console
    } else {
        clientLogger = window.Raven;
    }
}

export const LOG_ERROR = {
    level: 'error'
};

export const LOG_WARNING = {
    level: 'warning'
};

/* maybe we drop in something else here if we don't go with Raven */
export default clientLogger;
